(() => {
  const navRoot = document.querySelector('[data-kl-nav-root]') || document.querySelector('[data-kl-nav]');
  if (!navRoot) return;

  const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;
  const genderLinks = Array.from(document.querySelectorAll('[data-gender-link]'));
  const genderGroups = Array.from(document.querySelectorAll('[data-gender-group]'));
  const activeGenderHandles = new Set(
    genderLinks
      .filter((link) => link.getAttribute('aria-disabled') !== 'true')
      .map((link) => link.dataset.gender)
      .filter(Boolean)
  );
  const hideTimers = new WeakMap();
  let openWrapper = null;

  const readGenderCookie = () => {
    const match = document.cookie.match(/(?:^|; )kl_gender=([^;]+)/);
    try {
      return match ? decodeURIComponent(match[1]) : '';
    } catch {
      return '';
    }
  };

  const setGenderCookie = (handle) => {
    document.cookie = `kl_gender=${encodeURIComponent(handle)}; path=/; max-age=2592000`;
  };

  const setGender = (handle, { persist } = { persist: true }) => {
    if (!activeGenderHandles.has(handle)) return;
    genderLinks.forEach((link) => {
      link.classList.toggle('gender-item--active', link.dataset.gender === handle);
    });
    genderGroups.forEach((group) => {
      group.classList.toggle('is-active', group.dataset.genderGroup === handle);
    });
    document.querySelectorAll('[data-kl-nav], [data-kl-nav-root]').forEach((nav) => {
      nav.dataset.currentGender = handle;
    });
    document.querySelectorAll('[data-kl-sidebar-nav]').forEach((sidebar) => {
      sidebar.dataset.currentGender = handle;
      sidebar.querySelectorAll('[data-sidebar-gender]').forEach((item) => {
        item.hidden = Boolean(item.dataset.sidebarGender) && item.dataset.sidebarGender !== handle;
      });
    });
    if (persist) setGenderCookie(handle);
  };

  const pathSidebar = document.querySelector('[data-kl-sidebar-nav][data-gender-source="path"]');
  const pathGender = pathSidebar?.dataset.currentGender ||
    (navRoot.dataset.genderSource === 'path' ? navRoot.dataset.currentGender : '');
  if (activeGenderHandles.has(pathGender)) {
    // An explicit collection module wins over a stale cookie and persists for neutral pages.
    setGender(pathGender);
  } else {
    const cookieGender = readGenderCookie();
    const defaultSidebarGender = document.querySelector('[data-kl-sidebar-nav]')?.dataset.currentGender;
    const initialGender = [cookieGender, navRoot.dataset.currentGender, defaultSidebarGender]
      .find((handle) => activeGenderHandles.has(handle)) || activeGenderHandles.values().next().value;
    setGender(initialGender, { persist: false });
  }

  genderLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      if (link.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      const handle = link.dataset.gender;
      setGender(handle);
    });
  });

  const clearHideTimer = (menu) => {
    const timer = hideTimers.get(menu);
    if (timer) {
      clearTimeout(timer);
      hideTimers.delete(menu);
    }
  };

  const closeMenu = (wrapper, immediate = false) => {
    if (!wrapper) return;
    const menu = wrapper.querySelector('[data-mega-menu]');
    const trigger = wrapper.querySelector('[data-mega-trigger]');
    if (!menu || !trigger) return;
    menu.classList.remove('kl-mega-menu--open');
    wrapper.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    clearHideTimer(menu);
    const hide = () => {
      menu.hidden = true;
    };
    if (immediate) {
      hide();
    } else {
      const timer = setTimeout(hide, 220);
      hideTimers.set(menu, timer);
    }
    if (openWrapper === wrapper) openWrapper = null;
  };

  const openMenu = (wrapper) => {
    if (!wrapper) return;
    const menu = wrapper.querySelector('[data-mega-menu]');
    const trigger = wrapper.querySelector('[data-mega-trigger]');
    if (!menu || !trigger) return;
    if (openWrapper && openWrapper !== wrapper) closeMenu(openWrapper, true);
    clearHideTimer(menu);
    menu.hidden = false;
    menu.classList.add('kl-mega-menu--open');
    wrapper.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    openWrapper = wrapper;
  };

  const toggleMenu = (wrapper) => {
    if (!wrapper) return;
    const menu = wrapper.querySelector('[data-mega-menu]');
    if (!menu) return;
    if (menu.classList.contains('kl-mega-menu--open')) {
      closeMenu(wrapper, true);
    } else {
      openMenu(wrapper);
    }
  };

  document.querySelectorAll('[data-mega-wrapper]').forEach((wrapper) => {
    const trigger = wrapper.querySelector('[data-mega-trigger]');
    const menu = wrapper.querySelector('[data-mega-menu]');
    const closeBtn = wrapper.querySelector('[data-mega-close]');
    if (!trigger || !menu) return;
    const isDisclosure = trigger.tagName === 'BUTTON';

    wrapper.addEventListener('mouseenter', () => {
      if (!isMobile() && !isDisclosure) openMenu(wrapper);
    });

    wrapper.addEventListener('mouseleave', () => {
      if (!isMobile()) closeMenu(wrapper);
    });

    wrapper.addEventListener('focusin', () => {
      if (!isMobile() && !isDisclosure) openMenu(wrapper);
    });

    wrapper.addEventListener('focusout', (event) => {
      if (!isMobile() && !wrapper.contains(event.relatedTarget)) {
        closeMenu(wrapper);
      }
    });

    trigger.addEventListener('click', (event) => {
      if (isMobile() || isDisclosure) {
        event.preventDefault();
        toggleMenu(wrapper);
      }
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu(wrapper, true);
      }
      if (isMobile() && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        toggleMenu(wrapper);
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => closeMenu(wrapper, true));
    }

    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu(wrapper, true);
    });
  });

  document.addEventListener('click', (event) => {
    if (!openWrapper) return;
    if (!openWrapper.contains(event.target)) closeMenu(openWrapper, true);
  });

  window.addEventListener(
    'scroll',
    () => {
      if (openWrapper && !isMobile()) closeMenu(openWrapper, true);
    },
    { passive: true }
  );

  window.addEventListener('resize', () => {
    if (openWrapper) closeMenu(openWrapper, true);
  });

  document.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
    const parent = trigger.closest('.mobile-accordion');
    if (!parent) return;
    trigger.addEventListener('click', () => {
      const isOpen = parent.classList.toggle('mobile-accordion--open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
})();

